// extracted by mini-css-extract-plugin
export default {"container":"Error_container__vno2-"};